import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { printParcelCreditNote } from '../../../../utils/printers/CreditNote';

const PrintTripExpenseButton = ({parcel}) => {
  const handleTripExpense = () => {
    printParcelCreditNote(parcel);
  };

  return (
      <Button
        color="light"
        className="border"
        onClick={handleTripExpense}
      >
        <i className="fa fa-print" /> 
          {' '}Imprimir
      </Button>
    );
  }

PrintTripExpenseButton.propTypes = {
  parcel: PropTypes.instanceOf(Map).isRequired,
};

export default PrintTripExpenseButton;
